export default {
  methods: {
    getColor (property) {
      const defaultValue = null
      if (typeof property !== 'string') {
        return property
      }

      const colorValue = property.trim()
      if (!colorValue) {
        return defaultValue
      }

      // Si el valor ya es un color CSS válido (hex, rgb/rgba, hsl/hsla, nombre de color, etc.) se devuelve directamente.
      if (typeof CSS !== 'undefined' && CSS.supports && CSS.supports('color', colorValue)) {
        return colorValue
      }

      const rootStyles = getComputedStyle(document.documentElement)

      // Resuelve variables CSS en formato --nombre-variable (ej. --primary-DEFAULT).
      // Se llama recursivamente para asegurar que el valor resuelto también sea un color válido.
      if (colorValue.startsWith('--')) {
        const resolvedColor = rootStyles.getPropertyValue(colorValue).trim()
        return resolvedColor ? this.getColor(resolvedColor) : defaultValue
      }

      // Resuelve variables CSS en formato explícito var(--nombre-variable).
      // Se llama recursivamente para asegurar que el valor resuelto también sea un color válido.
      if (colorValue.startsWith('var(') && colorValue.endsWith(')')) {
        const variableName = colorValue.slice(4, -1).split(',')[0].trim()
        if (variableName.startsWith('--')) {
          const resolvedColor = rootStyles.getPropertyValue(variableName).trim()
          return resolvedColor ? this.getColor(resolvedColor) : defaultValue
        }
      }

      return defaultValue
    }
  }
}
